import { render } from "./ConsultAccreditOrderDetail.vue?vue&type=template&id=836d560c&scoped=true"
import script from "./ConsultAccreditOrderDetail.vue?vue&type=script&lang=js"
export * from "./ConsultAccreditOrderDetail.vue?vue&type=script&lang=js"

import "./ConsultAccreditOrderDetail.vue?vue&type=style&index=0&id=836d560c&scoped=true&lang=css"

import exportComponent from "D:\\京欣医疗用户端\\login_init\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836d560c"]])

export default __exports__